import { Card } from "primereact/card";
import style from "./PropertyDisclaimer.module.scss";

const PropertyDisclaimer: React.FC<{ isFromAnalyser: boolean | undefined }> = ({ isFromAnalyser }) => {
  return (
    <Card
      pt={{
        content: { className: style.contentOverride },
      }}
      id="disclaimer"
      title="Disclaimer"
      className={`grid grid-cols-1 text-xs md:text-sm text-justify leading-5 ${style.disclaimer}`}
    >
      <>
        {!isFromAnalyser && "1."} Please note: We will display all statistics where data is available for
        suburbs/postcodes. However some data is not visible where a large enough sample isn't available hence statistics
        may read "N/A" and some graphs may be missing.
        <br />
        {!isFromAnalyser &&
          "2.There may be additional overlays that affect this property, please check with your local council."}
      </>
    </Card>
  );
};

export default PropertyDisclaimer;
